import { useState } from 'react';
import { NextPageContext } from 'next';
import Head from 'next/head';
import { ScreenName } from 'common/utils/pp_tracking';
import { generateCookieList } from 'common/utils/trackingTag';
import MembershipPaymentSection from 'components/common/MembershipPaymentSection';
import { SITE_BASE_URL } from 'config/env';
import { parse } from 'cookie';
import useGlobalStore from 'store/global';

import styles from './MembershipPage.module.scss';

export default function MemberShipPage(): JSX.Element {
  const [isProcessing, setIsProcessing] = useState(false);
  const showMembershipPayDialogInput = useGlobalStore(
    (state) => state.showMembershipPayDialogInput,
  );
  const showPaymentDialogInput = useGlobalStore(
    (state) => state.showPaymentDialogInput,
  );

  const showTippingDialogInput = useGlobalStore(
    (state) => state.showTippingDialogInput,
  );

  const showingStripeInDialog =
    (!!showPaymentDialogInput?.creator?.is_creator &&
      showPaymentDialogInput?.creator?.is_open_for_subscription) ||
    !!showTippingDialogInput ||
    !!showMembershipPayDialogInput?.open;
  return (
    <>
      <Head>
        <title>PostPrime | メンバーシップ</title>
        <meta
          name="description"
          content="PostPrimeは、「お金」にまつわる情報交換ができるコミュニティを提供。ライブ配信・動画・音声・その他の投稿から学べ、また、過去のチャートパターンやテクニカル分析を学習したAI利用することにより、マーケットの評価など様々な分析機能を使うことができます。"
        />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="PostPrime メンバーシップ" />
        <meta
          property="og:description"
          content="PostPrimeは、「お金」にまつわる情報交換ができるコミュニティを提供。ライブ配信・動画・音声・その他の投稿から学べ、また、過去のチャートパターンやテクニカル分析を学習したAI利用することにより、マーケットの評価など様々な分析機能を使うことができます。"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content={`${SITE_BASE_URL}/p/membership`}
        />
        <meta name="twitter:title" content="PostPrime メンバーシップ" />
        <meta
          name="twitter:description"
          content="PostPrimeは、「お金」にまつわる情報交換ができるコミュニティを提供。ライブ配信・動画・音声・その他の投稿から学べ、また、過去のチャートパターンやテクニカル分析を学習したAI利用することにより、マーケットの評価など様々な分析機能を使うことができます。"
        />
        <link rel="canonical" href={`${SITE_BASE_URL}/p/membership`} />
      </Head>
      <div className={styles.membershipPage}>
        <div className={styles.container}>
          {!showingStripeInDialog && (
            <MembershipPaymentSection
              initPackage={null}
              initRecurring={null}
              showMembershipStatus={false}
              isProcessing={isProcessing}
              screenName={ScreenName.MembershipPage}
              setIsProcessing={setIsProcessing}
            />
          )}
        </div>
      </div>
    </>
  );
}

export const getServerSideProps = (context: NextPageContext) => {
  const cookiesList = generateCookieList(
    context.query,
    parse(context.req?.headers?.cookie || ''),
  );
  if (cookiesList.length > 0) {
    context.res.setHeader('Set-Cookie', cookiesList);
  }
  return {
    props: {},
  };
};
